import { AuthService } from './../../../core/services/auth/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidatorFn, FormArray, FormControl } from '@angular/forms';
import { IOption } from 'ng-select';
import { ValuesListService } from "../../../core/services/admin/values-list.service";
import { AlertService } from '../../../shared/services/alert.service';
import { BooksParameterService } from '../../../core/services/admin/books-parameter.service';
import { GeneralService } from '../../../shared/services/general.service';
import { ValidForm } from '../../../shared/services/ValidForm';
import { ModalAnimationComponent } from '../../../shared/components/modal-animation/modal-animation.component';
import { DataTable } from 'angular2-datatable';
@Component({
  selector: 'app-books-parameterization',
  templateUrl: './books-parameterization.component.html',
  styleUrls: ['./books-parameterization.component.scss'],
  providers: [BooksParameterService]
})
export class BooksParameterizationComponent implements OnInit {
  public fmrBook: FormGroup;
  public itemsType: any[] = [];
  public CatList: any[] = [
    { id: 1, name: "PRIMARY" },
    { id: 2, name: "SECONDARY" },
    { id: 3, name: "THIRD" }
  ];
  public currencylist: any[] = [];
  public bookList: Array<IOption> = [];
  public filterBy: string = "name";
  public mfData: any[];
  public data: any;
  public rowsOnPage = 5;
  public filterQuery = '';
  public sortBy = '';
  public sortOrder = 'desc';
  public showForm: boolean = false;
  public type: string;
  public ledgerSelected: any;
  public dataOperatingUnit: any;
  public title_input : string;
  public value_input : any;
  public selectedRow : number ;
  public selectedControl : string;
  private userData: any;
  private canEdit: boolean = true;

   @ViewChild('modal_input') modal_input: ModalAnimationComponent;
   @ViewChild('mf') tableLedger  : DataTable;

  constructor(private formBuilder: FormBuilder,
    private valuesList: ValuesListService,
    private _alertService: AlertService,
    private _BooksParameterService: BooksParameterService,
    private generalServ: GeneralService,
    private _authService: AuthService
  ) {
    this.buildValidations();
  }

  ngOnInit() {
    this._authService.getSession().then((data) => this.userData = data);
    this.getCurrency();
    this.getLedgers();
    this.selectTypes();
    this.validateProfile();
    // this.ledgers();
  }

  buildValidations(): void {
    this.fmrBook = this.formBuilder.group({
      ledgersForm: this.formBuilder.array([])
    });

  }
  selectTypes(): void {
    this.valuesList.getLookupsValues({ lookup_type: 'LOV_LEDGER_CATEGORY' },
      {
        success: resp => {
          if (resp.status === 0) {
            this.createSelect(resp.data);
            this.itemsType = this.createSelect(resp.data);
          }
        },
        error: err => {
          console.log(err);
        }
      });
  }

  createSelect(list: Array<any>): Array<IOption> {
    const lisTemp: Array<IOption> = list.map((item) => {

      return {
        value: item.lookup_code,
        label: item.description,
        data: item
      };
    });

    return lisTemp;
  }

  onSubmit() {
    if (!this.fmrBook.validate()) return;

    const dataJson: Array<any> = [];
    const dataForm: FormArray = <FormArray>this.fmrBook.controls['ledgersForm'];

    console.log(dataForm);

    dataForm.controls.forEach((control: FormGroup) => { 
      console.log(control);
      if (control.dirty) {
        let value_form = control.getRawValue();
        delete value_form['index'];
        dataJson.push(value_form);
      }
    });

    this.mergeLedgers(dataJson);
  }

  private resetForm() {
    this.fmrBook.reset();
    while (this.ledgersForm.length > 0) {
      this.ledgersForm.removeAt(0)
    }
  }

  get getColumns() {
    return [
      { name: 'id', description: 'Código' },
      { name: 'name', description: 'Nombre' },
      { name: 'description', description: 'Descripción' },
      { name: 'ledger_category_code', description: 'Categoría' },
      { name: 'currency_code', description: 'Moneda' },
      { name: 'segments_num', description: 'Nro de Segmentos contables' },
      { name: 'delimiter', description: 'Delimitador de Segmentos' },
      { name: '', description: 'Acciones' }
    ];
  }

  private getLedgers() {
    this._BooksParameterService.get_ledgers({
      success: res => {
        this.data = res.data;
        this.data.forEach(ledger => this.addRow(ledger));
        if (this.data.length == 0) this.addRow();
        console.log('this.data', this.data);
      },
      error: err => {
        console.log("error error -> ", err);
      },
      always: () => { },
      includeToken: false
    });
  }

  private getCurrency(): void {
    this.generalServ.getCurrency(
      {
        success: (resp: any) => {
          if (resp.status === 0) {
            this.currencylist = this.createSelectCurrency(resp.data);
          }
        },
        error: (err: any) => {
          console.log(err)
        }
      }
    )
  }

  private createSelectCurrency(list: Array<any>): Array<IOption> {
    const lisTemp: Array<IOption> = list.map((item) => {
      return {
        value: item.lookup_code,
        label: item.description,
        data: item
      };
    });
    return lisTemp;
  }

  get ledgersForm() { return <FormArray>this.fmrBook.get('ledgersForm') }

  public addRow(ledger?: any) {
    let index = this.ledgersForm.controls.length;
    const frmLedger = this.formBuilder.group({
      ledger_id: [ledger ? ledger.id : null, [Validators.required, ValidForm.numeric]],
      ledger_name: [ledger ? ledger.name : null, [Validators.required, Validators.maxLength(240)]],
      description: [ledger ? ledger.description : null, [Validators.maxLength(240)]],
      ledger_category_code: [ledger ? ledger.ledger_category_code : null, [Validators.maxLength(60)]],
      currency_code: [ledger ? ledger.currency_code : null, [Validators.maxLength(10)]],
      segments_num: [ledger ? ledger.segments_num : null],
      delimiter: [ledger ? ledger.delimiter : null, [Validators.maxLength(1)]],
      index : index
    });
    if (ledger) frmLedger.disable();
    this.ledgersForm.push(frmLedger);

    if (!length){
      let currentPage = Math.ceil(this.ledgersForm.controls.length/this.rowsOnPage);
      this.tableLedger.setPage(currentPage, this.rowsOnPage);
    }
  }

  private deleteLedger(ledger_id: number) {
    this._BooksParameterService.remove(ledger_id, {
      success: (resp) => {
        if (resp.status === 0) {
          this._alertService.openConfirmsSwal({
            text: resp.data,
            type: resp.message,
            confirmButtonText: 'Aceptar',
            handlerConfirm: () => { }
          });
          this.resetForm();
          this.getLedgers();
        }
      },
      error: (e) => {
        console.log('error => ', e);
        this._alertService.openSwal({
          text: e.message,
          type: 'error'
        });
      }
    });
  }

  public onDeleteLedger(formGroupName: any) {
    let ledgerForm: FormGroup = this.ledgersForm.controls[formGroupName] as FormGroup;
    console.log(ledgerForm);

    if (ledgerForm.getRawValue().ledger_id != null) {

      this._alertService.openConfirmsSwal({
        text: '¿Desea eliminar el registro?',
        type: 'question',
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        handlerConfirm: () => {
          this.deleteLedger(ledgerForm.getRawValue().ledger_id);
        },
      });

    } else {
      this.deleteRow(formGroupName);
    }
  }

  private deleteRow(formGroupName: any) {
    this.ledgersForm.removeAt(formGroupName);
    if (this.ledgersForm.controls.length == 0) this.addRow();
  }

  public enabledForm(formGroupName) {
    this.ledgersForm.controls[formGroupName].enable();
    this.ledgersForm.controls[formGroupName].get('ledger_id').disable();
    this.ledgersForm.controls[formGroupName].get('currency_code').disable();
  }

  private mergeLedgers(data: any) {
    this._BooksParameterService.mergeLedgers(data, {
      success: res => {
        if (res.status === 0) {
          this._alertService.openConfirmsSwal({
            text: res.message,
            type: 'success',
            confirmButtonText: 'Aceptar',
            showCancelButton: false,
            handlerConfirm: () => { }
          });
          this.resetForm();
          this.getLedgers();
        }
      },
      error: err => {
        console.log("saveRanges error -> ", err);
        this._alertService.openSwal({
          text: err.message,
          type: 'error'
        });
      },
      always: () => { },
      includeToken: false
    });
  }


  public showEntities(formGroupName: any) {
    this.ledgerSelected = (this.ledgersForm.controls[formGroupName] as FormGroup).getRawValue();
    console.log(this.ledgerSelected);
    this.getOperatingUnit(this.ledgerSelected.ledger_id);

  }

  private getOperatingUnit(ledger_id: number) {
    this._BooksParameterService.getOperatingUnit(ledger_id, {
      success: res => {
        console.log("getOperatingUnit res -> ", res);
        this.dataOperatingUnit = res.data;

      },
      error: err => {
        console.log("getOperatingUnit error -> ", err);
        this._alertService.openSwal({
          text: err.message,
          type: 'error'
        });
      },
      includeToken: false
    });
  }

  get getColumnsOperatingUnit() {
    return [
      { name: 'operating_unit', description: 'Código' },
      { name: 'operation_unit_name', description: 'Nombre' }
    ];
  }

  public OnUpdateOperatingUnit() {
    let jsonData: any = {
      "user_id": this.userData.id_usuario,
      "user_name": this.userData.username,
      "operating_units": this.dataOperatingUnit.map((item) => ({ operating_unit: item.operating_unit, checked: item.checked })
      )
    };

    this.UpdateOperatingUnit(this.ledgerSelected.ledger_id, jsonData);

    console.log(this.dataOperatingUnit);

  }

  private UpdateOperatingUnit(ledger_id: any, data: any) {
    this._BooksParameterService.UpdateOperatingUnit(ledger_id, data, {
      success: res => {
        if (res.status === 0) {
          this._alertService.openConfirmsSwal({
            text: res.message,
            type: 'success',
            confirmButtonText: 'Aceptar',
            showCancelButton: false,
            handlerConfirm: () => { }
          });
          this.getOperatingUnit(ledger_id);
        }
      },
      error: err => {
        console.log("saveRanges error -> ", err);
        this._alertService.openSwal({
          text: err.message,
          type: 'error'
        });
      },
      always: () => { },
      includeToken: false
    });
  }

  public showModalInput(title : string, index_row: number, formControl : string){
    this.title_input = title;
    this.selectedRow = index_row;
    this.selectedControl = formControl;
    this.value_input = this.ledgersForm.controls[this.selectedRow].get(this.selectedControl).value;
    
    this.modal_input.show('modal_input');
    setTimeout(() => {
      document.getElementById('txtAreaModalInput').focus();
    }, 600);
    
  }

  public setValue(){

    this.ledgersForm.controls[this.selectedRow].get(this.selectedControl).setValue(this.value_input);
    this.ledgersForm.controls[this.selectedRow].get(this.selectedControl).markAsDirty();

    this.selectedRow      = -1;
    this.selectedControl  = '';
    this.value_input      = '';
    this.modal_input.close('modal_input');


  }

  public validateProfile(){
    let userAudit =  localStorage.getItem("UserOnlyRead");

    if(userAudit == 'true'){
      this.canEdit = false;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/modules/accounting/books-parameterization/books-parameterization.component.ts